import { useState, useEffect } from 'react';
import variables from '../../styles/theme.scss';

const breakpoints = {
  mobile: `(max-width: ${variables.mobile})`,
  tablet: `(min-width: ${variables.tablet})`,
  desktop: `(min-width: ${variables.desktop})`,
};

export enum BreakPoint {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}

export const useMediaQuery = (breakpoint: BreakPoint): boolean => {
  const mediaQuery = breakpoints[breakpoint];
  const mediaQueryList = window.matchMedia(mediaQuery);

  const [isMatch, setIsMatch] = useState<boolean>(mediaQueryList.matches);

  useEffect(() => {
    const listener = () => setIsMatch(mediaQueryList.matches);
    listener();
    mediaQueryList.addEventListener('change', listener);

    return () => mediaQueryList.removeEventListener('change', listener);
  }, [breakpoint]);

  return isMatch;
};
